import actions from './actions';
import reducer from './reducer';

const additionalInfoRequired = {
    actions,
    reducer,
    name: 'additionalInfoRequired',
};

export default additionalInfoRequired;